/**
 * @desc 导出sku报价信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierQuotation.exportSupplierQuotation.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/exportSupplierQuotation`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
